import { render, staticRenderFns } from "./crewFoodDetail.vue?vue&type=template&id=40e6a2c8&scoped=true"
import script from "./crewFoodDetail.vue?vue&type=script&lang=js"
export * from "./crewFoodDetail.vue?vue&type=script&lang=js"
import style0 from "./crewFoodDetail.vue?vue&type=style&index=0&id=40e6a2c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e6a2c8",
  null
  
)

export default component.exports